import api from '@config/api'
import { useQuery } from 'react-query'
import {
    IQuizID,
    IRequestCreateQuiz,
    IRequestGetAllQuizs,
    IResponseGetAllQuizs,
    IRequestDeleteQuizByID,
    IRequestDeleteQuiz,
    IRequestUpdateQuiz,
} from '@apiinterface/IQuiz'
import { IRequestSaveContact } from '@apiinterface/IContact'
import { useFormMutationHandler } from '@utils/useFormMutationHandler'
import { IFormMutationHandlerProps } from '@interfaces/default/IDefault'
import { useQueryConfig } from './useQueryConfig'
interface IUseCreateQuiz
    extends IFormMutationHandlerProps<IRequestCreateQuiz> {}

interface IUseUpdateQuiz
    extends IFormMutationHandlerProps<IRequestUpdateQuiz> {}

interface IUseDeleteQuizByID
    extends IQuizID,
        IFormMutationHandlerProps<IRequestDeleteQuizByID> {}

interface IUseBulkDeleteQuiz
    extends IFormMutationHandlerProps<IRequestDeleteQuiz> {}

interface IUseSaveContact
    extends IFormMutationHandlerProps<IRequestSaveContact> {}
// interface IUseDeleteQuizs
//     extends IFormMutationHandlerProps<IRequestDeleteQuiz> {}
const Quiz = {
    useGetAllQuizs: ({
        limit = 100,
        orderby = 'quiz_id',
        order = 'desc',
        page = 1,
        search = '',
        created_at,
        person_type,
    }: IRequestGetAllQuizs) =>
        useQuery(
            'allquiz',
            async () => {
                try {
                    const res = await api.get('/quizs', {
                        params: {
                            limit,
                            orderby,
                            order,
                            page,
                            search,
                            created_at,
                            person_type,
                        },
                    })
                    return res.data.body as IResponseGetAllQuizs
                } catch (error) {
                    return Promise.reject(error)
                }
            },
            useQueryConfig
        ),

    useCreateQuiz: ({ form, aftersuccess }: IUseCreateQuiz) => {
        return useFormMutationHandler({
            form,
            pathWithMethod: ['/quizs', 'post'],
            aftersuccess,
        })
    },

    useUpdateQuiz: ({ form, aftersuccess }: IUseUpdateQuiz) => {
        return useFormMutationHandler({
            form,
            pathWithMethod: ['/quizs', 'put'],
            aftersuccess,
        })
    },

    useDeleteQuizById: ({ quiz_id, aftersuccess }: IUseDeleteQuizByID) => {
        return useFormMutationHandler({
            pathWithMethod: [`/quizs/${quiz_id}`, 'delete'],
            aftersuccess,
        })
    },
    useBulkDeleteQuiz: ({ aftersuccess, form }: IUseBulkDeleteQuiz) => {
        return useFormMutationHandler({
            pathWithMethod: [`/quizs`, 'delete'],
            aftersuccess,
            form,
        })
    },
    useSendMailPDF: ({ form, aftersuccess }: IUseSaveContact) => {
        return useFormMutationHandler({
            form,
            pathWithMethod: [`/quizs/pdf`, 'post'],
            aftersuccess,
        })
    },
}

export default Quiz
